import React, { useEffect, useState } from "react";
import LectureComp from "../components/LectureComp";
import FilterBox from "../components/FilterBox";
import Lectures from "./Lectures";
import Utils from "../utils/utils";
import { useToast } from "../components/ToastContext";

const MyCourse = ({ clickedLink }) => {
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const token = Utils.getToken();
  const user = Utils.getLoggedInUser();
  const [role, setRole] = useState(Utils.UserRole);
  const isVideo = clickedLink === "videos" ? "/videos" : "";

  const [lectures, setLectures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lectureToView, setLectureToView] = useState(null);
  const [activeButton, setActiveButton] = useState("today");
  const [activeFilter, setActiveFilter] = useState(false);

  const [allQuery, setAllQuery] = useState({
    title: "",
    category: "",
    lectureMode: "",
    instructorName: "",
    date: "",
  });

  const showToast = useToast();

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setAllQuery((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilterBtn = (e) => {
    e.preventDefault();
    setAllQuery({
      title: "",
      category: "",
      lectureMode: "",
      instructorName: "",
      date: "",
    });
    setActiveFilter(false);
  };

  async function fetchLectures(typeOfLecture) {
    const startDate = new Date(new Date().setHours(0, 0, 0, 0)).toJSON();
    const endDate = new Date(new Date().setHours(23, 59, 59, 999)).toJSON();
    const newQuery = allQuery;
    newQuery["lectureMode"] = "Live";
    if (clickedLink === "videos") {
      newQuery["lectureMode"] = "Video";
    }
    const query = `title=${newQuery.title}&category=${newQuery.category}&lectureMode=${newQuery.lectureMode}&instructorName=${newQuery.instructorName}&date=${newQuery.date}`;
    const urls = {
      today: `${SERVER_URL}/lectures/today-lecture${isVideo}?start=${startDate}&end=${endDate}`,
      upComing: `${SERVER_URL}/lectures/upcoming-lecture?end=${endDate}&video=${isVideo}`,
      all: `${SERVER_URL}/lectures?${query}`,
    };

    try {
      setLoading(true);
      const customURL = urls[typeOfLecture];
      let response = await fetch(customURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setLectures(data);
      } else {
        const errorData = await response.json();
        showToast(errorData.message, "error", true, 5000);
      }
    } catch (error) {
      // console.error("Error:", error.message);
    } finally {
      setLoading(false);
    }
  }

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const debouncedFetchLectures = debounce(
    () => fetchLectures(activeButton),
    1000
  );

  const handleAdminMode = (event) => {
    const checked = event.target.checked;
    if (checked) {
      setRole("Student");
    } else {
      setRole("Admin");
    }
  };

  const handleLectureClick = (lecture) => {
    const lectureTime = lecture.lectureTime;
    const joiningLink = lecture.joiningLink;
    const videoLink = lecture.videoLink;
    let originalLectureTime = new Date(lectureTime);
    let currentTime = new Date(new Date().toUTCString());

    if (lecture.lectureEndTime) {
      let t = new Date(lecture.lectureEndTime);
      if (currentTime > t && videoLink === "false") {
        showToast("Session ended", "info", false, 3000);
        return;
      }
    }

    if (currentTime >= originalLectureTime) {
      if (videoLink && videoLink !== "false") {
        setLectureToView(lecture);
      } else if (joiningLink) {
        window.open(joiningLink, "_blank");
      } else {
        showToast(
          "There is some error in joining in the lecture. Report Admin !!!",
          "error",
          true,
          5000
        );

        return;
      }
    } else {
      const LectureTime = Utils.getIndianTimeFromJSON(lectureTime);
      showToast(
        `Lecture will be available at ${LectureTime}.`,
        "warning",
        true,
        5000
      );
      return;
    }
  };

  const closeLectureComp = () => {
    setLectureToView(null);
  };

  useEffect(() => {
    debouncedFetchLectures();
  }, [allQuery.title]);

  useEffect(() => {
    fetchLectures(activeButton);
  }, [activeButton, clickedLink]);

  useEffect(() => {
    const reseted = Object.values(allQuery).every((value) => value === "");
    if (reseted) {
      fetchLectures("all");
    }
  }, [allQuery]);

  useEffect(() => {
    const lectureMode = clickedLink === "videos" ? "Video" : "Live";
    setAllQuery((prev) => ({ ...prev, lectureMode: lectureMode }));
  }, [clickedLink]);

  return (
    <div className="p-2 overflow-y-auto h-[calc(100vh-65px)]" bkl="MyCourse">
      {Utils.UserRole && Utils.UserRole.toLowerCase() === "admin" && (
        <div className="flex justify-end">
          <div
            className={` flex p-2 bg-white border-b-2 items-center px-2 rounded-2xl shadow-lg ${
              role === "Student" ? "border-pink-700" : ""
            }`}
          >
            <p className="text-md font-semibold mr-2">Student Mode</p>
            <input
              type="checkbox"
              className="toggle border-pink-700 bg-pink-700  [--tglbg:#faf5ff] hover:bg-pink-800"
              onChange={handleAdminMode}
            />
          </div>
        </div>
      )}

      <FilterBox
        clickedLink={clickedLink}
        allQuery={allQuery}
        handleFilterChange={handleFilterChange}
        activeFilter={activeFilter}
        activeButton={activeButton}
        setLoading={setLoading}
        setActiveFilter={setActiveFilter}
        resetFilterBtn={resetFilterBtn}
        setActiveButton={setActiveButton}
        fetchLectures={fetchLectures}
      />
      <Lectures
        token={token}
        user={user}
        role={role}
        loading={loading}
        lectures={lectures}
        setActiveButton={setActiveButton}
        setLectureToView={setLectureToView}
        handleLectureClick={handleLectureClick}
        setLectures={setLectures}
        activeButton={activeButton}
        fetchLectures={fetchLectures}
      />

      {lectureToView && (
        <LectureComp lecture={lectureToView} onClose={closeLectureComp} />
      )}
    </div>
  );
};

export default MyCourse;
